export const URI_PARAMS = {
  userId: 'userId',
  arrangementCode: 'arrangementCode',
  sourceUserId: 'sourceUserId',
  targetUserId: 'targetUserId',
  methodSlug: 'methodSlug',
};
